import type { ReactNode } from 'react';

import { PdfPreviewProvider, useSharedPdfViewerGate } from '@liscio/common';

import { FirmPdfPreview } from './FirmPdfPreview';
import { reportPdfViewerError } from './reportPdfViewerError';

/**
 * Must render inside LaunchDarklyProvider. Follows the live flag: flags can be
 * empty on first render, and each preview holds the renderer it opened with.
 */
export function FirmPdfPreviewProvider({ children }: { children: ReactNode }) {
  const sharedViewer = useSharedPdfViewerGate(null);
  return (
    <PdfPreviewProvider
      renderer={sharedViewer ? FirmPdfPreview : null}
      onError={reportPdfViewerError}
    >
      {children}
    </PdfPreviewProvider>
  );
}
